import React from "react";
import { useMantineTheme } from '@mantine/core';

import PickerDate from "../general/PickerDate";

const TanggalMasukProjectDibatalkan = ({ stateData }) => {

    const theme = useMantineTheme();

    return (
        <React.Fragment>
            <PickerDate
                stateReadOnly={true}
                stateDate={stateData.data.value}
                stateVariant="default"

                stateStylesInput={{
                    backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7]
                }}

                fnSetDate={() => { }}

                stateLabel={stateData.data.label}
                statePlaceHolder={stateData.data.placeholder}
                stateWithAsterisk={stateData.data.withAsterisk}
                stateDescription={stateData.data.description}
                stateError={stateData.data.error}
            />
        </React.Fragment>
    )
}

export default TanggalMasukProjectDibatalkan;